// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.kore-chat-window .lineChartChildDiv .mouse-over-effects .mouse-per-line text {
  font-size: 12px;
}

.kore-chat-window .linechart .linechartDiv {
  display: block;
  border-radius: 4px;
  clear: both;
  margin-left: -45px;
  width: 353px;
  box-shadow: 0 1px 5px 0 rgba(179, 186, 200, 0.58);
  cursor: pointer;
  background-color: #ffffff;
}

.kore-chat-window .lineChartChildDiv {
  margin-left: 13px;
  width: 340px;
}

.kore-chat-window .linechart .messageBubble.linechart {
  margin-bottom: 10px;
}

.kore-chat-window .linechart .profile-photo {
  top: 30px;
}

[dir=rtl].kore-chat-window .linechart .linechartDiv {
  margin-right: -45px;
  direction: ltr;
}`, "",{"version":3,"sources":["webpack://./src/plugins/v2Plugin/templates/lineChartTemplate/lineChartTemplate.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;AACJ;;AACA;EACI,cAAA;EACA,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,iDAAA;EACA,eAAA;EACA,yBAAA;AAEJ;;AACA;EACI,iBAAA;EACA,YAAA;AAEJ;;AACA;EACI,mBAAA;AAEJ;;AACA;EACI,SAAA;AAEJ;;AACA;EACI,mBAAA;EACA,cAAA;AAEJ","sourcesContent":[".kore-chat-window .lineChartChildDiv .mouse-over-effects .mouse-per-line text {\n    font-size: 12px;\n}\n.kore-chat-window .linechart .linechartDiv {\n    display: block;\n    border-radius: 4px;\n    clear: both;\n    margin-left: -45px;\n    width: 353px;\n    box-shadow: 0 1px 5px 0 rgba(179, 186, 200, 0.58);\n    cursor: pointer;\n    background-color: #ffffff;\n}\n\n.kore-chat-window .lineChartChildDiv {\n    margin-left: 13px;\n    width: 340px;\n}\n\n.kore-chat-window .linechart .messageBubble.linechart {\n    margin-bottom: 10px;\n}\n\n.kore-chat-window .linechart .profile-photo {\n    top: 30px;\n}\n\n[dir=\"rtl\"].kore-chat-window .linechart .linechartDiv{\n    margin-right: -45px;\n    direction: ltr;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
